<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn w-140" v-if="type == 1 || type == 2">
      <el-select
        class="select_btn_style"
        v-model="filters.bindStatus"
        placeholder="浙政钉绑定状态"
      >
        <el-option
          v-for="(item, i) in userBindStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn w-160" v-if="type == 1 || type == 3">
      <el-select
        class="select_btn_style"
        v-model="filters.pushStatus"
        placeholder="干部之家同步状态"
      >
        <el-option
          v-for="(item, i) in classPushStatusList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn" v-if="type == 3">
      <el-select
        class="select_btn_style"
        v-model="filters.bizType"
        placeholder="学习形式"
      >
        <el-option
          v-for="(item, i) in ticketTypeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn w-160" v-if="type == 4">
      <el-select
        class="select_btn_style "
        v-model="filters.bizType"
        placeholder="上次预约学习形式"
      >
        <el-option
          v-for="(item, i) in ticketTypeList"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn w-160">
      <el-input
        clearable
        placeholder="请选择工作单位"
        v-model="deptName"
        @focus="showDeptModal"
        @clear="clearDepts">
      </el-input>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.userName"
        :placeholder="type == 3 ? '姓名/手机号' : '姓名'"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" :title="'查询'" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
    <SingleCheckTree ref="lazyTree" :defaultCheckedKeys="defaultCheckedKeys" :showModal="deptDialog" @deptSelected="selectDept" showTooltip/>
  </el-form>
</template>

<script>
import { getSysParamByTypes } from "@/api/sysParam";
import SingleCheckTree from "./singleCheckTree";
import butn from "@/components/button/index";
export default {
  components: {
    butn,
    SingleCheckTree
  },
  data() {
    return {
      deptDialog: {
        flag: false
      },
      filters: {
        deptLevelCodeQuery: "",
      },
      deptName: "",
      defaultCheckedKeys: [],
      classPushStatusList: [],
      ticketTypeList: [],
      userBindStatusList: [],
    };
  },
  props: {
    type: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getSysParamByTypes([ "CLASS_PUSH_STATUS", 'COURSE_TICKET_TYPE', "USER_BIND_STATUS"]);
  },
  methods: {
    // 获取多个数据字典
    getSysParamByTypes(types) {
      getSysParamByTypes({ types: types }).then((res) => {
        if (!res || res.code != 0) return;
        res.data["CLASS_PUSH_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["COURSE_TICKET_TYPE"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        res.data["USER_BIND_STATUS"].splice(0, 0, {
          paramKey: "",
          paramValue: "全部",
        });
        this.classPushStatusList = res.data["CLASS_PUSH_STATUS"];
        this.ticketTypeList = res.data["COURSE_TICKET_TYPE"];
        this.userBindStatusList = res.data["USER_BIND_STATUS"];
      });
    },
    initData() {
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      this.filters = {};
      this.deptName = "";
      this.clearDepts();
      this.$emit("search", { t: new Date().getTime() });
    },
    // 选择工作单位弹窗
    showDeptModal() {
      this.deptDialog.flag = true;
    },
    clearDepts() {
      this.defaultCheckedKeys = [];
      this.filters.deptLevelCodeQuery = "";
      this.$nextTick(()=> {
        this.$refs.lazyTree.$refs["deptTree"]?.setCheckedKeys(this.defaultCheckedKeys);
      })
    },
    // 工作单位选择确定
    selectDept(dept) {
      this.deptName = dept.deptName;
      this.filters.deptLevelCodeQuery = dept.deptLevelCode;
      this.defaultCheckedKeys = [dept.uuid];
      this.deptDialog.flag = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.w-160 {
  width: 160px;
}
.w-140 {
  width: 140px;
}
</style>
